import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControlName][appPhoneMask]',
})
export class PhoneMaskDirective {

  constructor(private el: ElementRef, private ngControl: NgControl) { }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    let input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos

    if (value.length > 11) {
      value = value.slice(0, 11); // Limita a 11 dígitos
    }

    let formattedValue = this.formatPhoneNumber(value);

    input.value = formattedValue;
    this.ngControl.control?.setValue(formattedValue, { emitEvent: false }); // Atualiza o FormControl sem emitir outro evento
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any) {
      const input = event.target as HTMLInputElement;
      let value = input.value;
      if (value.length < 14 && value.length > 0){ // (DD) 9999-9999
          this.ngControl.control?.markAsTouched();
          this.ngControl.control?.updateValueAndValidity();
      }
  }

  private formatPhoneNumber(value: string): string {
    let formattedValue = '';

    if (value.length > 0) {
      formattedValue = '(' + value.substring(0, Math.min(2, value.length));
    }
    if (value.length > 2) {
      formattedValue += ') ' + value.substring(2, Math.min(7, value.length));
    }
    if (value.length > 7) {
      formattedValue += '-' + value.substring(7, 11);
    }

    return formattedValue;
  }
}


// import { Directive, HostListener, ElementRef } from '@angular/core';
// import { NgControl } from '@angular/forms';

// @Directive({
//   selector: '[formControlName][appPhoneMask]',
// })
// export class PhoneMaskDirective {

//   constructor(private el: ElementRef, private ngControl: NgControl) { }

//   @HostListener('ngModelChange', ['$event'])
//   onModelChange(event:any) {
//     this.onInputChange(event, false);
//   }

//   @HostListener('keydown.backspace', ['$event'])
//   keydownBackspace(event:any) {
//     this.onInputChange(this.el.nativeElement.value, true);
//   }

//   onInputChange(event:any, backspace:any) {
//     let newVal = event.replace(/\D/g, '');
//     if (backspace && newVal.length <= 6) {
//       newVal = newVal.substring(0, newVal.length - 1);
//     }
//     if (newVal.length === 0) {
//       newVal = '';
//     } else if (newVal.length <= 2) {
//       newVal = '(' + newVal;
//     } else if (newVal.length === 3) {
//       newVal = '(' + newVal.substring(0, 2) + ') ' + newVal.substring(2);
//     } else if (newVal.length === 7) {
//       newVal = '(' + newVal.substring(0, 2) + ') ' + newVal.substring(2, 7) + '-' + newVal.substring(7);
//     } else if (newVal.length === 11) {
//       newVal = '(' + newVal.substring(0, 2) + ') ' + newVal.substring(2, 7) + '-' + newVal.substring(7);
//     } else if (newVal.length > 11) {
//       newVal = '(' + newVal.substring(0, 2) + ') ' + newVal.substring(2, 7) + '-' + newVal.substring(7, 11);
//     }
//     this.ngControl.control?.setValue(newVal, {emitEvent: false});
//   }

// }
